module.exports = __webpack_public_path__ + "static/media/3.8f22fd67.png";